import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const userOperationPrivilege = {
  namespaced: true,

  state: () => ({
    loading: false,
    userPrivilegeRegistrationSuccess: false,
    userPrivilegeRegistrationFailure: false
  }),

  getters: {
    _loading: state => state.loading,
    _userPrivilegeRegistrationSuccess: state =>
      state.userPrivilegeRegistrationSuccess,
    _userPrivilegeRegistrationFailure: state =>
      state.userPrivilegeRegistrationFailure
  },

  mutations: {
    LOADING (state, value) {
      state.loading = value
    },
    InHouseUserOperationPriviledge_REGISTRATION_SUCCESS (state, value) {
      state.userPrivilegeRegistrationSuccess = value
    },
    InHouseUserOperationPriviledge_REGISTRATION_FAILURE (state, value) {
      state.userPrivilegeRegistrationFailure = value
    }
  },

  actions: {
    CreateInHouseUserOperationPriviledge ({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        api
          .post('/InHouseUserOperationPriviledge/CreateInHouseUserOperationPriviledge', payload, {
            headers
          })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            commit('LOADING', false)
            commit('InHouseUserOperationPriviledge_REGISTRATION_SUCCESS', true)
            resolve(response)
          })
          .catch(error => {
            commit('LOADING', false)
            commit('InHouseUserOperationPriviledge_REGISTRATION_FAILURE', true)
            reject(error)
          })
      })
    },
    RemoveInHouseUserOperationPriviledge ({ rootState, commit }, xpressUserAppOperationPriviledgeId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .delete(
            `/InHouseUserOperationPriviledge/RemoveInHouseUserOperationPriviledge?xpressUserAppOperationPriviledgeId=${xpressUserAppOperationPriviledgeId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllInHouseUserOperationPriviledgeByID ({ rootState, commit }, XpressDepartmentAppOperationId) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            `/InHouseUserOperationPriviledge/GetAllInHouseUserOperationPriviledgeByID?XpressDepartmentAppOperationId=${XpressDepartmentAppOperationId}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetInHouseUserOperationPriviledgeByUserID ({ rootState, commit }, userID) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            `/InHouseUserOperationPriviledge/GetInHouseUserOperationPriviledgeByUserID?userID=${userID}`,
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllInHouseUserOperationPriviledge ({ rootState, commit }) {
      return new Promise((resolve, reject) => {
        const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
        commit('LOADING', true)
        api
          .get(
            '/InHouseUserOperationPriviledge/GetAllInHouseUserOperationPriviledge',
            { headers }
          )
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default userOperationPrivilege
